import { redirect, replace, type RouteObject } from "react-router";
import * as AppRoute from "#routes/app/AppRoute.tsx";

export const routes: RouteObject[] = [
  {
    id: "root",
    children: [
      {
        id: "app",
        ...AppRoute,
        children: [
          {
            path: "auth",
            children: [
              {
                path: "sign-in",
                loader() {
                  throw redirect("/");
                },
                children: [
                  {
                    path: "callback",
                  },
                ],
              },
              {
                path: "sign-out",
                loader() {
                  throw redirect("/");
                },
                children: [
                  {
                    path: "callback",
                  },
                ],
              },
            ],
          },
          {
            id: "authorized",
            middleware: [
              async () => {
                const { amplifyClient } = await import("#amplifyClient.ts");
                const session = await amplifyClient.getAuthSession();
                if (!session.userSub) {
                  throw redirect("/login");
                }
              },
            ],
            children: [
              {
                id: "layout",
                lazy: () => import("#routes/layout/Layout.tsx"),
                children: [
                  {
                    path: "games/:leagueId",
                    middleware: [
                      ({ request, params }) => {
                        if (
                          params.leagueId &&
                          params.leagueId.toUpperCase() !== params.leagueId
                        ) {
                          throw replace(
                            new URL(request.url).pathname.replace(
                              `games/${params.leagueId}`,
                              `games/${params.leagueId.toUpperCase()}`
                            )
                          );
                        }
                      },
                    ],
                    lazy: () => import("#routes/games/GameLayoutRoute.tsx"),
                    children: [
                      {
                        index: true,
                        lazy: () => import("#routes/games/games-feed/GamesFeedRoute.tsx"),
                      },
                      {
                        path: ":eventId",
                        lazy: () => import("#routes/games/game-details/GameDetailsRoute.tsx"),
                      },
                    ],
                  },
                  {
                    index: true,
                    lazy: () => import("#routes/Index.tsx"),
                  },
                ],
              },
            ],
          },
          {
            path: "/login",
            loader: async () => {
              const { amplifyClient } = await import("#amplifyClient.ts");
              const session = await amplifyClient.getAuthSession();
              if (session.userSub) {
                throw redirect("/");
              }
            },
            lazy: () => import("#routes/login/Login.tsx"),
          },
          {
            path: "/login/confirm",
            lazy: () => import("#routes/login/Confirm.tsx"),
          },
        ],
      },
    ],
  },
];

declare module "react-router" {
  export interface Future {
    v8_middleware: true;
  }
}
